import { t } from '@/utility/localization';
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';
import { useImperativeHandle } from 'react';
import NPLButton from '@/components/npl/NPLButton';
import Icon from '@/components/npl/Icon';

const InputList = ({ itemList, addItem, deleteItem, setInput }, ref) => {
  const inputRef = useRef();
  const [showInput, setShowInput] = useState(true);

  useImperativeHandle(ref, () => ({
    focus: () => {
      if (inputRef.current) inputRef.current.focus();
    }
  }));

  const onKeyDown = useCallback(
    (e) => {
      const key = e.which;
      //on enter click or comma
      if ((key === 13 || key === 188) && inputRef?.current?.value) {
        addItem({
          url: inputRef?.current?.value,
          callback: () => (inputRef.current.value = '')
        });
        e.preventDefault();
        return;
      }
    },
    [addItem]
  );

  useEffect(() => {
    const inputEle = inputRef.current;
    if (inputEle && showInput)
      inputEle.addEventListener('keydown', onKeyDown);
    return () => {
      if (inputEle && showInput)
        inputEle.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown, showInput]);

  // <div className="w-[400px]">
  return (
    <div>
      <p className="mb-8 text-label-lg font-medium text-dark-1b">
        {t('link1')}
      </p>
      <div className="mb-8 space-y-8">
        {itemList.map((item) => (
          <div
            className="flex w-full items-center space-x-8"
            key={item.id}>
            <div className="flex-1 break-words rounded-4 border-1 border-light-e0 px-16 py-12 text-14 text-neutral-10">
              {item.link}
            </div>
            <span
              role="button"
              tabIndex={0}
              onClick={() => deleteItem({ id: item.id })}>
              <Icon name="trash-01" fill="#191c1e" />
            </span>
          </div>
        ))}
      </div>
      {showInput && (
        <input
          ref={inputRef}
          className="w-full rounded-8 border-1 border-npl-neutral-light-solid-7 bg-white-default px-16 py-12 text-14 text-neutral-10"
          placeholder="https://youtu.be/ndddJzbxWqs"
          onChange={(e) => setInput(e.target.value)}
          onBlur={(e) =>
            addItem({
              url: e.target.value,
              callback: () => setShowInput(false)
            })
          }
        />
      )}

      <div className="mt-24">
        <NPLButton
          hierarchy="outline"
          size="sm"
          onClick={() => setShowInput(true)}
          leadIcon="plus"
          buttonText={t('add-another-link')}
        />
      </div>
    </div>
  );
};

export default forwardRef(InputList);
